import { createContext, useContext } from 'react';
import { ProposalResponse } from 'services/actions/ai_management_proposal';
import { ProposalStep } from 'services/ai_management_proposal';

// Cada etapa informa as próprias pendências, avisa quando grava (indicador "Salvando…") e
// devolve a proposta que a gravação respondeu.
export interface ProposalShell {
  setPendencies: (step: ProposalStep, count: number) => void;
  trackSave: <T>(request: Promise<T>) => Promise<T>;
  // target: o data-proposal-target do elemento que a etapa deve rolar até e destacar.
  goToStep: (step: ProposalStep, target?: string) => void;
  applyProposal: (data: ProposalResponse) => void;
  focusTarget: string | null;
  // Espaço à direita do título da etapa: cada etapa põe ali as próprias ações (createPortal).
  stepActions: HTMLElement | null;
  // Espaço no rodapé, ao lado do "Voltar": a revisão põe ali o "Gerar proposta".
  footerActions: HTMLElement | null;
}

const noop = () => undefined;

export const ProposalShellContext = createContext<ProposalShell>({
  setPendencies: noop,
  trackSave: (request) => request,
  goToStep: noop,
  applyProposal: noop,
  focusTarget: null,
  stepActions: null,
  footerActions: null,
});

export const useProposalShell = () => useContext(ProposalShellContext);
